import { useMemo } from 'react';
import { getQueryParameters } from 'utils/url';

export function useQueryParameters(names: string[]) {
  return useMemo(
    () => getQueryParameters(names, window.location.search),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [window.location.search, names],
  );
}

export default useQueryParameters;
